import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader } from "react-bootstrap";
import { IoIosClose } from "react-icons/io";
import { getFormObj, server_domain } from "../../../services/constants";
import { useDispatch } from "react-redux";
import { post } from "../../../services/axios";
import { setError } from "../../../redux/appsettingSlice";

const ExchangeModal = ({ id: _id, show, close, data, voucher, reload }) => {
  const [checked, setChecked] = useState();

  const dispatch = useDispatch();
  const { html, checkbox } = useMemo(() => {
    if (!data?.data || !data?.value) return;

    const split = data?.data;

    const headSplit = split[0]?.split(voucher);
    const head = `<p class="mb-0">${
      headSplit[0]
    } <strong>(${voucher} ${headSplit[1]
      .replace("(", "")
      .trim()})</strong>${headSplit[2].replace(")", "")}</p><br/>`;

    const value = `<p class="mb-0">Voucher value: <strong>£${data?.value}</strong></p><br/>`;

    const creditSplit = split[1].split(":");

    const credit = `<p class="mb-0">${creditSplit[0]}: <strong>${creditSplit[1]}</strong></p><br/>`;
    const termsHead = `<p class="mb-0">${split[2]}</p><br/>`;

    const termsPoint1 = split[3];
    const termsPoint2 = split[4];
    const termsPoint3 = split[5];
    const storeString = split[6];
    // const storeLink = storeString.split("online store");
    // const termsPoint4 = `${storeLink[0]}<a href="https://app.unlok.it/" target="_blank" rel="noopener noreferrer">online store</a>${storeLink[1]}`;
    const termsPoint4 = storeString;
    const termsPoint5 = split[7];

    const terms = `<ul class="mb-0"><li>${termsPoint1}</li><li>${termsPoint2}</li><li>${termsPoint3}</li><li>${termsPoint4}</li><li>${termsPoint5}</li></ul><br/>`;
    const checkboxEl = split[8].replace("[ ] ", "");
    // const checkboxLink = checkboxEl.split("(found here)");
    // const checkbox = `${checkboxLink[0]} (<a href="https://www.exceedgiving.com/terms" target="_blank" rel="noopener noreferrer">found here</a>)`;
    const checkbox = checkboxEl;
    const html = head + value + credit + termsHead + terms;

    return data?.data ? { html, checkbox } : {};
  }, [data]);

  const handleExchange = async () => {
    let rdata = getFormObj();
    rdata.append("api_method", "redeem_voucher");
    rdata.append("voucher_id", _id);
    rdata.append("redeem", "exchange");

    try {
      const response = await post(server_domain, rdata);

      if (response.status === 200) {
        close();
        reload(_id);
        submitFailed(response.data);
      }
      if (response.data.error) {
        submitFailed(response.data);
      }
    } catch (err) {
      submitFailed(err);
    }
  };

  // const submitError = (response) => {
  //   dispatch(
  //     setError({
  //       isShow: true,
  //       alert_title: response.data.alert_title,
  //       alert_text: response.data.alert_text,
  //       alert_action_button_title: "Close",
  //       alert_action_url: "/",
  //     })
  //   );
  // };

  const submitFailed = (err) => {
    dispatch(
      setError({
        isShow: true,
        alert_title: "Error",
        alert_text: "",
        alert_action_button_title: "",
        alert_action_url: "",
        message: err.message.toString(),
      }),
    );
  };

  return (
    <Modal show={show} onHide={close} centered className="">
      <ModalHeader className="fs-4" style={{ color: "#ababab" }}>
        Exchange your voucher{" "}
        <IoIosClose style={{ cursor: "pointer" }} onClick={close} />
      </ModalHeader>
      <Modal.Body style={{ color: "#ababab" }}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
        <div className="d-flex gap-3">
          <input
            type="checkbox"
            name="terms"
            id="terms"
            checked={checked}
            onChange={() => setChecked((prev) => !prev)}
          />
          <div dangerouslySetInnerHTML={{ __html: checkbox }} />
        </div>
        {checked && (
          <button
            className="w-100 my-3 py-2 buttony-gold text-dark badge fs-6"
            onClick={handleExchange}
          >
            Exchange my voucher for a credit of £{data.value}
          </button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ExchangeModal;
